import React, { Component } from 'react';
import PropTypes from 'prop-types';

const productQuantityOptions = (product, quantity) => {
  let items = [];

  for(let i=0; i<=quantity; i++) {
    items.push(<option value={i} key={i}>{i}</option>);
  }

  return items;
}

const Checkout = props =>
  <div className="cart">
    <h1 className="cart-title">{App.t('cart.title_2')}</h1>
    <ul className="cart-products">
      <li className="cart-productsHead">
        <p className="cart-productsHeadLabel -main">{App.t('cart.table_articles')}</p>
        <p className="cart-productsHeadLabel -quantity">{App.t('cart.table_quantity')}</p>
        <p className="cart-productsHeadLabel -price">{App.t('cart.table_price')}</p>
      </li>

      {props.products.map((product, i) => {
        return (
          <li className="cartProduct" key={i}>
            <span className="cartProduct-photo">
              <img className="cartProduct-photoImg" src={product.picture} />
            </span>
            <div className="cartProduct-main">
              <strong className="cartProduct-bands">{product.bands}</strong>
              <span className="cartProduct-name">{product.name}</span>
              <span className="cartProduct-type">
                {product.type}
                {product.includedType ? ` + ${product.includedType}` : null}
              </span>
            </div>
            <span className="cartProduct-quantity">
              <button className="cartProduct-remove btn-cartRemove" type="button" onClick={() => props.deleteFromCart(product)}>{App.t('cart.delete')}</button>
              {product.itemsLeft > 0 ?
                <select className="input-select cartProduct-quantitySelect" value={product.quantity} onChange={e => props.setQuantity(product, e.target.value)}>
                  {productQuantityOptions(product, product.itemsLeft)}
                </select>
                :
                (product.isDownloadable ?
                  <select className="input-select cartProduct-quantitySelect" value={product.quantity} onChange={e => props.setQuantity(product, e.target.value)}>
                    {productQuantityOptions(product, 1)}
                  </select>
                : <span className="cartProduct-quantityUnavailable">-</span>)
              }
            </span>
            <span className="cartProduct-price">
              {product.totalPrice} €
            </span>
          </li>
        )
      })}
    </ul>

    {props.amounts.shipping !== null &&
      <div className="cart-shipping">
        <div className="cart-shippingCountry">
          <span className="cart-shippingCountryLabel">{App.t('cart.ship_to')}</span>
          <select className="input-select" value={props.shippingCountry} onChange={props.changeCountry}>
            {_metadata.countries.map(c =>
              <option key={c.value} value={c.value}>{c.label}</option>
            )}
          </select>
        </div>
        <p className="cartProduct-price -shipping">{props.amounts.shipping} €</p>
      </div>
    }

    <div className="cart-footer">
      <p className="cart-footerAmount">{App.t('cart.total_amount', { amount: props.amounts.total })}</p>
      <p className="cart-footerInfo">{App.t('cart.vat_included')}</p>
      <button className="btn -green" onClick={props.goNext}>{App.t('cart.go_to_2')}</button>
    </div>
  </div>;

Checkout.propTypes = {
  shippingCountry:  PropTypes.string.isRequired,
  changeCountry:    PropTypes.func.isRequired,
  setQuantity:      PropTypes.func.isRequired,
  deleteFromCart:   PropTypes.func.isRequired,
  goNext:           PropTypes.func.isRequired,
  amounts:          PropTypes.object.isRequired,
  products:         PropTypes.array.isRequired,
};

export default Checkout;
